import { css, StyleSheet } from 'aphrodite';
import React from 'react';

type Appearance =
  | 'default'
  | 'success'
  | 'information'
  | 'attention'
  | 'warning';

const colors = {
  white: '#ffffff',
  gray: '#6f6f87',
  blue: '#1a66ff',
  green: '#00b67a',
  yellow: '#ffaf05',
  red: '#eb1700',
};

export const borderRadius = {
  small: 2,
  medium: 3,
  large: 6,
};

export interface BadgeProps {
  /** String to be rendered inside the button */
  children: React.ReactNode;
  /** Appearance of badge */
  appearance?: Appearance;
}

export const Badge: React.FC<BadgeProps> = ({
  children,
  appearance = 'success',
}) => (
  <span className={css(styles.wrapper)}>
    <div className={css(styles.div, styles[appearance])}/>
    <span className={css(styles.label)}>{children}</span>
  </span>
);

const styles = StyleSheet.create({
  wrapper: {
    display: 'flex',
    padding: '0',
    background: 'none',
    color: colors.gray,
    alignItems: 'center',
    justifyContent: 'flex-start',
    borderRadius: borderRadius.small
  },
  div: {
    borderRadius: '50%',
    display: 'inline-block',
    marginRight: '8px',
    width: '10px',
    height: '10px',
  },
  label: {
    fontFamily: 'Lato',
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 400,
    letterSpacing: '0.3px',
    display: 'inline',
    textTransform: 'none',
  },
  default: {
    background: colors.gray,
    color: colors.white,
  },
  information: {
    background: colors.blue,
    color: colors.white
  },
  success: {
    background: colors.green,
    color: colors.white
  },
  attention: {
    background: colors.yellow,
    color: colors.gray
  },
  warning: {
    background: colors.red,
    color: colors.white
  },
});



// WEBPACK FOOTER //
// ./src/CommonUI/UI/Badge.tsx